import Button from '@material-ui/core/Button'
import React, { useEffect } from 'react'
import { FaBell, FaEnvelope, FaSms } from 'react-icons/fa'

import { requestPostMarkedNotificationAsSeen } from '../../../../services/notifications'
import getCookie from '../../../../utils/getCookies'
import { sanitizeHtml } from '../../../../utils/sanitizeHtml'
import { useStyles } from './styles'

interface DialogProps {
  onCloseModal: () => void
  data: {
    id: string
    titulo: string
    texto: string
    lido: boolean
    tipo: string
    created_at: string
  }
}

export function DialogNotify({ data, onCloseModal }: DialogProps): JSX.Element {
  const classes = useStyles()
  const token: string | null = getCookie('gov_access_token_sso')

  useEffect(() => {
    async function requestMarkedNotification() {
      if (data.lido === false) {
        await requestPostMarkedNotificationAsSeen({
          token,
          notificationId: data.id,
        })
      }
    }
    requestMarkedNotification()
  }, [token, data])

  useEffect(() => {
    const handleAcessibility = (event: KeyboardEventInit) => {
      if (event.key === 'Escape') {
        onCloseModal()
      }
    }

    if (data) {
      document.addEventListener('keydown', handleAcessibility)
    }

    return () => {
      document.removeEventListener('keydown', handleAcessibility)
    }
  }, [data, onCloseModal])
  return (
    <>
      <div className={classes.allContent} onClick={onCloseModal} />
      <dialog className={classes.dialog}>
        <div className={classes.mainContent}>
          <section className={classes.headerNotify}>
            {data.tipo === 'EMAIL' && (
              <FaEnvelope size={40} className={classes.iconNotify} />
            )}
            {data.tipo === 'SMS' && (
              <FaSms size={40} className={classes.iconNotify} />
            )}
            {data.tipo === 'PUSH' && (
              <FaBell size={40} className={classes.iconNotify} />
            )}
            <div className={classes.sectionInformation}>
              <h1 className={classes.title}>{data.titulo}</h1>
            </div>
          </section>

          <div
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.texto) }}
            className={classes.bodyContent}
          />
          <div className={classes.footerSection}>
            <Button onClick={onCloseModal} className={classes.buttonClose}>
              FECHAR
            </Button>
          </div>
        </div>
      </dialog>
    </>
  )
}
